export const DEFAULT_MAX_SMS_PARTS = 3;
const GSM_7_EXTENDED_CHARS = new Set([`^`, `{`, `}`, `\\`, `[`, `~`, `]`, `|`, `€`]);
export function getSmsEncoding() {
    // Twilio smart-encoding normalizes many non-GSM characters before send.
    // We assume GSM-7 limits everywhere for consistent FE/BE estimates.
    return `GSM7`;
}
export function getSmsUnits(text) {
    let units = 0;
    for (const char of text) {
        units += GSM_7_EXTENDED_CHARS.has(char) ? 2 : 1;
    }
    return units;
}
export function getSmsMetrics(text, maxParts = DEFAULT_MAX_SMS_PARTS) {
    const encoding = getSmsEncoding();
    const units = getSmsUnits(text);
    const singlePartLimit = 160;
    const multipartLimit = 153;
    const parts = units === 0 ? 0 : units <= singlePartLimit ? 1 : Math.ceil(units / multipartLimit);
    const maxUnits = multipartLimit * maxParts;
    return {
        encoding,
        units,
        parts,
        singlePartLimit,
        multipartLimit,
        maxUnits,
    };
}
export function clampSmsToMaxParts(text, maxParts = DEFAULT_MAX_SMS_PARTS) {
    let next = ``;
    for (const char of text) {
        const candidate = `${next}${char}`;
        const metrics = getSmsMetrics(candidate, maxParts);
        if (metrics.parts > maxParts) {
            break;
        }
        next = candidate;
    }
    return next;
}
//# sourceMappingURL=smsUtils.js.map